import { jsx as _jsx } from "react/jsx-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { CreateConsentModal } from '../../components/create_consent_modal';
import { PARTICIPANT_DOCUMENTS_QUERY_KEY } from '../../utils/invalidate_signed_document_queries';
export const useCreateConsentAction = ({ participant, canCreateDocument, isDocGenEconsentEnabled, environment, siteId, accountId, getApiInstance, getApiErrorMessage, openClassicCreateConsent, onDocumentCreated, }) => {
    const queryClient = useQueryClient();
    const [isCreateConsentModalOpen, setIsCreateConsentModalOpen] = useState(false);
    const invalidateParticipantDocuments = () => {
        if (participant?._id) {
            void queryClient.invalidateQueries({ queryKey: [PARTICIPANT_DOCUMENTS_QUERY_KEY, participant._id] });
        }
    };
    const handleCreateConsent = () => {
        if (isDocGenEconsentEnabled) {
            setIsCreateConsentModalOpen(true);
            return;
        }
        openClassicCreateConsent();
    };
    const createConsentModal = canCreateDocument && isDocGenEconsentEnabled && isCreateConsentModalOpen && participant
        ? createPortal(_jsx(CreateConsentModal, { isOpen: true, onClose: () => setIsCreateConsentModalOpen(false), participant: participant, environment: environment, siteId: siteId, accountId: accountId, getApiInstance: getApiInstance, getApiErrorMessage: getApiErrorMessage, onInviteSuccess: (createdDocumentId) => {
                invalidateParticipantDocuments();
                if (createdDocumentId) {
                    onDocumentCreated?.(createdDocumentId);
                }
            } }), document.body)
        : null;
    return { handleCreateConsent, createConsentModal };
};
